import { ProductType } from "@shared-model/products/ProductType";

export class ProductHelper {

  static isProductTypeBundleSession(productTypeId: number): boolean {
    return productTypeId == ProductType.IvrBundleSession || productTypeId == ProductType.ImBundleSession;
  }

  static isProductTypeBundle(productTypeId: number): boolean {
    return productTypeId == ProductType.IvrBundleSession ||
      productTypeId == ProductType.ImBundleSession ||
      productTypeId == ProductType.IvrBundleTopUp ||
      productTypeId == ProductType.ImBundleTopUp;
  }

  static isProductTypePaygSession(productTypeId: number): boolean {
    return productTypeId == ProductType.IvrPaygSession || productTypeId == ProductType.ImPaygSession;
  }

  static isProductTypePayg(productTypeId: number): boolean {
    return productTypeId == ProductType.IvrPaygSession ||
      productTypeId == ProductType.ImPaygSession ||
      //productTypeId == ProductType.IvrPaygTopUp ||
      productTypeId == ProductType.ImPaygTopUp;
  }

  static isProductTypeGeneralTopUp(productTypeId: number): boolean {
    return productTypeId == ProductType.GeneralTopUp;
  }

  static isProductTypeMinutesTopUp(productTypeId: number): boolean {
    return productTypeId == ProductType.MinutesTopUp;
  }

  static isProductTypeOnlineChat(productTypeId: number): boolean {
    return productTypeId == ProductType.ImBundleSession ||
      productTypeId == ProductType.ImPaygSession ||
      productTypeId == ProductType.ImBundleTopUp ||
      productTypeId == ProductType.ImPaygTopUp;
  }

  static isProductTypeIvr(productTypeId: number): boolean {
    return productTypeId == ProductType.IvrBundleSession ||
      productTypeId == ProductType.IvrPaygSession ||
      productTypeId == ProductType.IvrBundleTopUp;// ||
      //productTypeId == ProductType.IvrPaygTopUp;
  }

  static isOfferLoyalty(offerId: number): boolean {
    return offerId == 14;
  }

  static isOfferIntroductory(offerId: number): boolean {
    return offerId == 15 || offerId == 16;
  }

}
